module.exports = __webpack_public_path__ + "img/goodw1.a4efb461.png";